import AssessmentDetail from "pages/Courses/AssessmentDetails";
import CourseDetail from "pages/Courses/CourseDetail";
// import Courses from "pages/Courses/Courses";
import TrainerDashboard from "pages/Dashboards/TrainerDashboard";
import InstructorProfile from "pages/Profile/InstructorProfile";
// import QuestionBank from "pages/QuestionBank/QuestionBank";
// import QuestionBankList from "pages/QuestionBank/QuestionBankList";
// import Questions from "pages/QuestionBank/Questions";
// import QuestionBankDetails from "pages/QuestionBank/QuestionBankDetails";
import CourseArtifacts from "pages/Courses/CourseArtifacts";
import InstructorCourses from "pages/Instructors/Courses/InstructorCourses";
import BatchListing from "pages/BatchManagement/BatchListing";
import BatchDetails from "pages/BatchManagement/BatchDetails";
import Assessment from "pages/Assessment/Assessment";
import OfflineAttendance from "pages/AttendanceModule/InstructorsLogin/OfflineAttendance";
import DailyAttendanceReport from "pages/Reports/DailyAttendanceReport";
import AssessmentReport from "pages/Reports/AssessmentReport";
import AssessmentReportDetails from "pages/Reports/AssessmentReportDetails";

const routes = [
  {
    show: true,
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-shop text-deep-blue",
    component: <TrainerDashboard />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: false,
    path: "/profile",
    name: "Instructor Profile",
    icon: "ni ni-shop text-deep-blue",
    component: <InstructorProfile />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: true,
    path: "/my-courses",
    name: "Assigned Courses",
    icon: "ni ni-hat-3 text-deep-blue",
    component: <InstructorCourses />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: false,
    path: "/my-courses/:id/details",
    name: "Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <CourseDetail />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: false,
    path: "/course/:id/details/:assessmentId",
    name: "Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <AssessmentDetail />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  // {
  //   show: true,
  //   path: "/sessions",
  //   name: "Sessions",
  //   icon: "ni ni-calendar-grid-58 text-deep-blue",
  //   component: <SessionsList />,
  //   layout: "/instructor",
  //   roles: ["TRAINER"],
  // },
  // {
  //   show: false,
  //   path: "/sessions/view/:sessionId",
  //   name: "Sessions Details",
  //   icon: "ni ni-calendar-grid-58 text-deep-blue",
  //   component: <SessionAttendance />,
  //   layout: "/instructor",
  //   roles: ["TRAINER"],
  // },
  // {
  //   show: true,
  //   path: "/question-bank",
  //   name: "Question Bank",
  //   icon: "ni ni-collection text-deep-blue",
  //   component: <QuestionBankList />,
  //   layout: "/instructor",
  //   roles: ["TRAINER"],
  // },
  // {
  //   show: false,
  //   path: "/question-bank/add",
  //   name: "Question Bank",
  //   icon: "ni ni-collection text-deep-blue",
  //   component: <QuestionBank />,
  //   layout: "/instructor",
  //   roles: ["TRAINER"],
  // },
  // {
  //   show: false,
  //   path: "/question-bank/add/questions",
  //   name: "Question Bank",
  //   icon: "ni ni-collection text-deep-blue",
  //   component: <Questions />,
  //   layout: "/instructor",
  //   roles: ["TRAINER"],
  // },
  // {
  //   show: false,
  //   path: "/question-bank/:id",
  //   name: "Question Bank",
  //   icon: "ni ni-collection text-deep-blue",
  //   component: <QuestionBankDetails />,
  //   layout: "/instructor",
  //   roles: ["TRAINER"],
  // },
  {
    show: true,
    path: "/batch",
    name: "Batches",
    icon: "fa-solid fa-solid fa-calendar-days text-deep-blue pr-4",
    component: <BatchListing />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: false,
    path: "/batch/:id/details",
    name: "Batch Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <BatchDetails />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: true,
    path: "/attendance",
    name: "Attendance",
    icon: "ni ni-book-bookmark text-deep-blue",
    component: <OfflineAttendance />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: true,
    path: "/assessment",
    name: "Assessments",
    icon: "ni ni-paper-diploma text-deep-blue",
    component: <Assessment />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: true,
    collapse: true,
    name: "Reports",
    icon: "ni ni-chart-bar-32 text-deep-blue",
    state: "reportsCollapse",
    roles: ["TRAINER"],
    views: [
      {
        show: true,
        path: "/reports/daily-attendance",
        name: "Daily Attendance Report",
        miniName: "DAR",
        component: <DailyAttendanceReport />,
        layout: "/instructor",
        roles: ["TRAINER"],
      },
      {
        show: true,
        path: "/reports/assessment-report",
        name: "Assessment Report",
        miniName: "AR",
        component: <AssessmentReport />,
        layout: "/instructor",
        roles: ["TRAINER"],
      },
    ],
  },
  {
    show: false,
    path: "/reports/assessment-report/:assessmentId/details/:batchId",
    name: "Assessment Report Details",
    icon: "ni ni-chart-bar-32 text-deep-blue",
    component: <AssessmentReportDetails />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: false,
    path: "/my-courses/:id/details/artifacts",
    name: "Course Artifacts",
    icon: "ni ni-shop text-deep-blue",
    component: <CourseArtifacts />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
];
export default routes;
